/**
 *	shop-schedule.ctrl.js
 */

class ShopScheduleCtrl {
    constructor($scope) {
    	this.weekDays = ['duminica', 'luni', 'marti', 'miercuri', 'joi', 'vineri', 'sambata'];
    	this.today = this.getTodaysName();
    }

    getTodaysName() {
    	var today = (new Date()).getDay();
        return this.weekDays[today];
    }
}

ShopScheduleCtrl.$inject = ['$scope'];

export default ShopScheduleCtrl;